import { showToast } from "../../../components";

export const handleConnect = (socket) => {
  ("Socket connected:", socket.id);
  // showToast("Connected to socket server", "success", 5000);
};

export const handleDisconnect = (reason) => {
  ("Socket disconnected:", reason);
  // showToast("Disconnected from socket", "error", 5000);
};

export const handleConnectError = (err) => {
  const message = err?.message || "Unknown socket error";
  console.error("Socket connection error:", err);
  // showToast(`Socket connection error: ${message}`, "error", 10000);
};
